<div class="flex flex-wrap gap-2 h-[22rem] overflow-y-auto pr-2">
    @if (hasActiveAttachments()) {
        @for (attachment of attachments.controls; track attachment) {
            @if (attachment.value.isDeleted === false) {
                <app-attachment-item
                    class="w-full"
                    [applicationId]="applicationId"
                    [form]="attachment"
                    (removeAttachment)="removeAttachment($event)"
                ></app-attachment-item>
            }
        }
    } @else {
        <p class="text-sm text-gray-500 italic">No attachments added.</p>
    }
</div>
